import { API } from '../constants/constants';
import { AxiosError } from 'axios';
import { normalizeReportRequestBody } from '../utils/reportNormalization';

export const sendServicesReport = async (body: any) => {
  try {
    const response = await API.post(`/mail/reports/service`, normalizeReportRequestBody(body ?? {}));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    const error: AxiosError = e as AxiosError;
    const respMsg = (error.response?.data as { message?: string } | undefined)?.message ?? error.message;
    return { error: 1, status: error.response?.status, message: respMsg };
  }
};

export const sendIssuesReport = async (body: any) => {
  try {
    const response = await API.post(`/mail/reports/issue`, normalizeReportRequestBody(body ?? {}));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    const error: AxiosError = e as AxiosError;
    return { error: 1, message: error.message, status: error.response?.status };
  }
};

export const sendEngagementsReport = async (body: any) => {
  try {
    const response = await API.post(`/mail/reports/engagement`, normalizeReportRequestBody(body ?? {}));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    const error: AxiosError = e as AxiosError;
    return { error: 1, message: error.message, status: error.response?.status };
  }
};
